import AText from './index.vue';

AText.install = app => {
  app.component(AText.name, AText);
};

export default AText;
